exports.resolveLink = function (doc) {
  if (doc) {
    switch (doc.type) {
      case "homepage":
      case "nav":
        return "/";
      case "page":
        return `/${doc.uid.replace(/_/g, "/")}/`;
      default:
        return `/${doc.type}/`;
    }
  }

  return "/";
};
